import { render, staticRenderFns } from "./AgeDescFromYear.vue?vue&type=template&id=6c5e3bf4&"
import script from "./AgeDescFromYear.vue?vue&type=script&lang=js&"
export * from "./AgeDescFromYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports